// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchForm_wrapper__1eFYJ","content":"SearchForm_content__1R7oj","field":"SearchForm_field__czYeF","title":"SearchForm_title__3XxkM","input":"SearchForm_input__3RpO6"};